

import { useState, createContext, useContext, useCallback, useMemo } from "react";
import { getLangSetting, getCrfTokenRefresh } from "../services/user-services";
import { getMatGroups } from "../services/material-services";
import { Cookies as useCookies } from 'react-cookie';
// import * as ReactCookie from 'react-cookie';
// import { CookiesProvider, useCookies } from 'react-cookie';

const AuthContext = createContext(null)
export const AuthProvider = ({user, tekGroup, tekLang, children}) => {

    const [ authData, setAuthData ] = useState(user)
    const [ authDataGroup, setAuthDataGroup ] = useState(tekGroup)
    const [ authDataLang, setAuthDataLang ] = useState(tekLang)
    const [ loginAgain, setLoginAgain ] = useState(false)
    

    // const getLangID = async (country) =>{
    //     const data = await getLangugeId(country)
    //     return data
    // }

    const getGroupList = async (idLang) =>{
        const data = await getMatGroups(idLang, '')
        return data
    }
    
    const getDataSetting = async (idLang) =>{
        const data = await getLangSetting(idLang)
        return data
    }

    const getDataUserCookies = async () =>{
        const cook = new useCookies();
        const refresh_token = cook.get('refresh_token')
        let flag = 0
        let crfAccessToken = ""
        if(refresh_token){
            const access_token = cook.get('access_token')
            if(refresh_token && access_token){
                crfAccessToken = await getCrfTokenRefresh({'refresh' : refresh_token, 'access': access_token})

                if (crfAccessToken){
                    if (crfAccessToken?.access === access_token){
                        flag = 1
                    }
                }else{
                    setLoginAgain(true)
                    localStorage.removeItem('teknokey')
                }
            }
        }
        if(flag === 1){
            return crfAccessToken
        }
        return null
    }
    // getDataUserCookies()
    const getDateCookies = () =>{
        const cook = new useCookies();
        const ref_teken = cook.get('ref_teken')
        return ref_teken
    }

    const setDateCookies = useCallback(() =>{
        const cook = new useCookies();
        let timeUpdate = getDateCookies()
        if (!timeUpdate){
            let dateExpire = new Date(Date.now() + (1 * 60 * 60 * 1000))
            cook.set('ref_teken', dateExpire.getTime(), { path: '/',  expires: dateExpire });
        }
    }, [])

    const getAuth = useCallback(async() => {
        const userData = await getDataUserCookies()
        if(userData?.user){
            localStorage.setItem('teknokey', encodeURIComponent(JSON.stringify(userData)))
        }else{
            localStorage.removeItem('teknokey')
        }
        return userData
    }, [])

    // useEffect(() => {
    //     let userData = authData
    //     if(!userData?.user){
    //         getAuth()
    //     }
    // }, [authData, setAuthData])

    const getGroup = useCallback(async(lang_id) => {
    // const getGroup = async() => {
        let GroupIndex = ''
        // const data = await getIPInfo()
        // let lId = await getLangID(data?.country)
        // if(!data){
        //     lId = await getLangID('Iran')
        // }
        // if(lId){
        // if(lId[0]?.lang > 0){
            const groupList = await getGroupList(lang_id)
            const numRows = groupList.length
            if(numRows > 0){
                GroupIndex = groupList[0]
                setAuthDataGroup(groupList[0])
                localStorage.setItem('tekGroup', encodeURIComponent(JSON.stringify(GroupIndex)))
                
                // localStorage.setItem('dataSWG', encodeURIComponent(JSON.stringify(GroupIndex)))
            }
        // }

    }, []);
        // return GroupIndex
    // }

    // useEffect(() => {
    //     let userData = authData
    //     if(!userData?.user){
    //         getAuth()
    //     }
    //     let GroupIndex = authDataGroup
    //     if(!GroupIndex?.id){
    //         getGroup()
    //     }
    // }, [authDataGroup, setAuthDataGroup])

    const getDataSite = useCallback(async(lang_id) => {
        let dataSetting = tekLang
        if(!dataSetting?.id){
            // const data = await getIPInfo()
            // let lId = await getLangID(data?.country)
            // if(!data){
            //     lId = await getLangID('Iran')
            // }
            // if(lId){
                
                dataSetting = await getDataSetting(lang_id)
                if(dataSetting){
                    setAuthDataLang(dataSetting)
                    localStorage.setItem('tekLang', encodeURIComponent(JSON.stringify(dataSetting)))
                }
            // }
        }
        // return dataSetting
    }, [tekLang]);

    useMemo(() => {
        let userData = authData
        let timeUpdate = getDateCookies()
        if(!userData?.user || !timeUpdate){
            getAuth()
        }
        // let GroupIndex = authDataGroup
        // if(!GroupIndex?.id || !timeUpdate){
        //     getGroup(273)
        // }
        // let siteSetting = authDataLang
        // if(!siteSetting?.id || !timeUpdate){
        //     getDataSite(273)
        // }
        setDateCookies()

    }, [authData, authDataGroup, getAuth, authDataLang, setDateCookies])

    const setAuth = newUser => {
        if(newUser){
            localStorage.setItem('teknokey', encodeURIComponent(JSON.stringify(newUser)))
            // localStorage.setItem('teknokey', newUser)
        }else{
            localStorage.removeItem('teknokey')
        }
        setAuthData(newUser)
    }

    // const setAuth = useCallback(newUser => {
    //     if(newUser){
    //         localStorage.setItem('teknokey', encodeURIComponent(JSON.stringify(newUser)))
    //         // localStorage.setItem('teknokey', newUser)
    //     }else{
    //         localStorage.removeItem('teknokey')
    //     }
    //     setAuthData(newUser)
    // }, [authData]);

    // const setAuthSetting = newSetting => {
    //     if(newSetting){
    //         localStorage.setItem('tekSetting', encodeURIComponent(JSON.stringify(newSetting)))
    //         // localStorage.setItem('tekSetting', JSON.stringify(newSetting))
    //     }else{
    //         localStorage.removeItem('tekSetting')
    //     }
        
    //     setAuthSiteSetting(newSetting)
    // }

    // const setAuthSetting = useCallback(newSetting => {
    //     if(newSetting){
    //         localStorage.setItem('tekSetting', encodeURIComponent(JSON.stringify(newSetting)))
    //         // localStorage.setItem('tekSetting', JSON.stringify(newSetting))
    //     }else{
    //         localStorage.removeItem('tekSetting')
    //     }
        
    //     setAuthSiteSetting(newSetting)

    // }, [authSiteSetting]);


    const setAuthGroup = newGroup => {
        if(newGroup){
            
            localStorage.setItem('tekGroup', encodeURIComponent(JSON.stringify(newGroup)))
            // localStorage.setItem('tekGroup', JSON.stringify(newGroup))
        }else{
            localStorage.removeItem('tekGroup')
        }
        
        setAuthDataGroup(newGroup)
    }

    // const setAuthGroup = useCallback(newGroup => {
    //     if(newGroup){
    //         localStorage.setItem('tekGroup', encodeURIComponent(JSON.stringify(newGroup)))
    //         // localStorage.setItem('tekSetting', JSON.stringify(newGroup))
    //     }else{
    //         localStorage.removeItem('tekGroup')
    //     }
        
    //     setAuthDataGroup(newGroup)

    // }, [authDataGroup]);

    const setAuthLang = newLang => {
        if(newLang){
            localStorage.setItem('tekLang', encodeURIComponent(JSON.stringify(newLang)))
            // localStorage.setItem('tekLang', JSON.stringify(newLang))
        }else{
            localStorage.removeItem('tekLang')
        }
        
        setAuthDataLang(newLang)
    }

    // const setAuthLang = useCallback(newLang => {
    //     if(newLang){
    //         localStorage.setItem('tekLang', encodeURIComponent(JSON.stringify(newLang)))
    //         // localStorage.setItem('tekSetting', JSON.stringify(newSetting))
    //     }else{
    //         localStorage.removeItem('tekLang')
    //     }
        
    //     setAuthDataLang(newLang)

    // }, [authDataLang]);

    return (
        // {/* <AuthContext.Provider value={{_data, setAuth, setAuthGroup, setAuthLang, setAuthSetting}}> */}
        <AuthContext.Provider value={{ authData, setAuth, setAuthGroup, authDataGroup, setAuthLang, authDataLang, loginAgain}}>
            {children}
        </AuthContext.Provider>
    )
}

export const useAuth = () => useContext(AuthContext);